/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetOrCreateTransactionReferenceRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetOrCreateTransactionReferenceResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getOrCreateTransactionReference = (request: GetOrCreateTransactionReferenceRequest, options?: CashRequestOptions) => post<GetOrCreateTransactionReferenceRequest, GetOrCreateTransactionReferenceResponse>("/2.0/cash/get-or-create-transaction-reference", request, {...options, rejectOnError: true })